import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

interface ItemProps {
  className?: string;
  label: string;
  value: string | number;
}

export const Item = (props: ItemProps) => {
  return (
    <div className={cn('flex flex-col', props.className)}>
      <Text size='2xl'>{props.value}</Text>
      <Text weight={PaletteUtils.isInsigniaPalette ? 'medium' : 'semibold'} color={PaletteUtils.isVcfcPalette ? 'secondary-light' : 'secondary'}>
        {props.label}
      </Text>
    </div>
  );
};
